module.exports = " <div ui-grid=$ctrl.grid></div> <br/> ";